import { Subject } from 'rxjs';

const subject = new Subject();

export const generalSettingsTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};